import React from 'react';
import { Button, DialogActions, Typography } from '@material-ui/core';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { deleteObjectiveKPIEntry } from '../../../api/objective/objectiveKPIEntry.api';

const DeleteKPIEntry = ({
  kpi,
  kpiEntry,
  objective,
  onSubmitSuccess,
  onCancel
}) => {
  const { t } = useTranslation();

  const deleteMutation = useMutation(
    async () => {
      await deleteObjectiveKPIEntry({
        kpiId: kpi.objectiveKPIId,
        entryId: kpiEntry.objective_kpi_entry_id,
        objectiveId: objective.id,
        ownerId: objective.owner[0].id,
        ownerType: objective.owner[0].type
      });
    },
    {
      onSuccess: onSubmitSuccess
    }
  );

  return (
    <div>
      <Typography>
        {t('objective.kpi.entryDeleteConfirmation')}
      </Typography>
      <Typography>
        <b>{kpi.name}</b> {kpiEntry?.value} {kpi.unit}
      </Typography>
      <DialogActions style={ { marginTop: 8 } }>
        <Button onClick={ deleteMutation.mutate } color='primary' variant='contained'>
          { t('objective.dialog.save') }
        </Button>
        <Button onClick={ onCancel } color='primary'>
          { t('objective.dialog.cancel') }
        </Button>
      </DialogActions>
    </div>
  );
};

export default DeleteKPIEntry;
